import { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Buttons, AddNewAppModal, NotificationModal } from 'components';
import { useParams, useNavigate } from 'react-router-dom';
import { Plus } from 'assets/icons';
import { routes } from 'config';
import { redirectToOldPlatformUrl } from 'utils';
import { appNumberToPromote } from 'store/selectors';

const checkUrl = (objParams) => {
  const value = objParams['*'];
  if (value === 'manage_apps/new') return true;
  return false;
};

const ManageAppsPage = ({ isWebsite = false }) => {
  const params = useParams();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(() => checkUrl(params));

  const handleClose = (pba_id = '') => {
    if (document.referrer.includes('/Discovery/Campaign.aspx')) {
      const newUrl = redirectToOldPlatformUrl(`/Discovery/Campaign.aspx?app=${pba_id}`);
      window.location.href = newUrl;
      return;
    }
    if (checkUrl(params)) {
      const url = routes.list.find((route) => route.id === 'manageApps').url;
      navigate(url);
    }
    setIsOpen(false);
  };

  return (
    <>
      <Buttons.PrimaryNormal
        id={`Add_New_${isWebsite ? 'URL' : 'App'}`}
        name={`Add new ${isWebsite ? 'URL' : 'App'}`}
        icon={<Plus />}
        onClick={() => setIsOpen(true)}
      >
        {`Add new ${isWebsite ? 'URL' : 'App'}`}
      </Buttons.PrimaryNormal>
      {isOpen && (
        <AddNewAppModal
          open={isOpen}
          handleClose={handleClose}
          title={`Add new ${isWebsite ? 'URL' : 'App'}`}
          isWebsite={isWebsite}
        />
      )}
    </>
  );
};

const CampaignPage = ({ chooseAction, isWebsite = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isWarningOpen, setIsWarningOpen] = useState(false);
  const selectedItem = useSelector(appNumberToPromote);
  const currentIsWebsite = useSelector(
    (state) => state?.general?.mainCampaignObject?.currentCampaignObj?.isWebsite,
  );

  const handleClose = () => {
    setIsOpen(false);
  };

  const shouldWarnOnTypeSwitch = Boolean(selectedItem) && currentIsWebsite !== isWebsite;

  const handleOpen = useCallback(() => {
    if (shouldWarnOnTypeSwitch) {
      setIsWarningOpen(true);
      return;
    }
    setIsOpen(true);
  }, [shouldWarnOnTypeSwitch]);

  const handleWarningContinue = useCallback(() => {
    setIsWarningOpen(false);
    setIsOpen(true);
  }, []);

  return (
    <>
      <Buttons.SecondaryNormal
        id={`Add_New_${isWebsite ? 'URL' : 'App'}`}
        name={`Add new ${isWebsite ? 'URL' : 'App'}`}
        onClick={handleOpen}
      >
        {`Add new ${isWebsite ? 'URL' : 'App'}`}
      </Buttons.SecondaryNormal>
      {isWarningOpen && (
        <NotificationModal
          onCancel={handleWarningContinue}
          onConfirm={handleWarningContinue}
          title="Switching between 'App' and 'Website'"
          iconType={NotificationModal.iconTypes.warning}
          iconSign='!'
          confirmBtnType={NotificationModal.btnTypes.PrimaryNormal}
          confirmBtnText='Ok'
        >
          All type-specific data (like URL or Package selection) will be cleared.
        </NotificationModal>
      )}

      {isOpen && (
        <AddNewAppModal
          chooseAction={chooseAction}
          open={isOpen}
          handleClose={handleClose}
          isWebsite={isWebsite}
          isAppHidden={isWebsite}
          isWebsiteHidden={!isWebsite}
        />
      )}
    </>
  );
};

const AddNewAppBtn = { ManageAppsPage, CampaignPage };

export default AddNewAppBtn;
